import React from "react";
import "./TabContentPartnerDetails.scss";
import { useAppSelector } from "../../../../../redux";

const TabContentPartnerDetails = () => {
  const { partnerDetails } = useAppSelector((state) => state.partner_details);
  const tableValue = [
    {
      label: "Email ID",
      value: partnerDetails?.partner_email,
    },
    {
      label: "HID Account Manager Email ID",
      value: partnerDetails?.account_manager,
    },
    {
      label: "Corporate Website",
      value: partnerDetails?.website,
    },
    {
      label: "Phone Number",
      value: partnerDetails?.company_contact,
    },
    {
      label: "Region",
      value: partnerDetails?.region,
    },
		{
      label: "Country",
      value: partnerDetails?.country,
    },
		{
      label: "Street Address",
      value: partnerDetails?.street_address,
    },
  ];

  const checkEmptyString = (value: string) => {
    if (value?.length > 0) return value;
    else return "-";
  };

  return (
    <div className="tab-content-partner-details-container">
      <div className="detail-table">
        {tableValue.map((row, index) => {
          return (
            <div
              className="table-row"
              style={index === 0 ? { borderTop: "none" } : {}}
              key={row.label}
            >
              <div className="label">{row.label}</div>
              {row.label === "Description" ? (
                <div
                  className="value"
                  dangerouslySetInnerHTML={{
                    __html: checkEmptyString(row.value),
                  }}
                ></div>
              ) : (
                <div className="value">{checkEmptyString(row.value)}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TabContentPartnerDetails;
